/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Modal,
  DatePicker,
} from 'antd';
import FormSubmitControls from 'components/FormSubmitControls';
import Table from 'components/Table';
import { onError } from 'utils/handlers';
import { DATE_FRONTEND_FORMAT, dateFormatterToReporteador } from 'utils/formatValues';
import { FilePdfOutlined } from '@ant-design/icons';
import { postObtenerReporte } from 'api/reporteador';
import Previewer, { downloadBase64 } from 'components/Previewer';
import usePermissionMessage from 'hooks/usePermissionMessage';
import { getReceptoresDePagos } from 'api/catalogos/receptoresDePagos';
import Select from 'components/Select';

// const dataOaxaca = [
//   {
//     id: 10021,
//     nombre: 'Auxiliar Detallado de Captacion',
//   },
// ];
const data = [
  {
    id: 10031,
    nombre: 'Carga de Póliza',
  },
  {
    id: 10032,
    nombre: 'Carga SAP',
  },
  {
    id: 10052,
    nombre: 'Layout Carga Detallado por Dia',
  },
  {
    id: 10044,
    nombre: 'Órdenes Procesadas por Instituciones Bancarias Global',
  },
  // {
  //   id: 34,
  //   nombre: 'Detallado de Ingresos',
  // },
  // {
  //   id: 48,
  //   nombre: 'Detallado de Ingresos Global',
  // },
  // {
  //   id: 39,
  //   nombre: 'Detallado de Ingresos por Unidad Recaudadora',
  // },
  // {
  //   id: 42,
  //   nombre: 'Acumulado de Ingresos por Unidad Recaudadora',
  // },
  // {
  //   id: 49,
  //   nombre: 'Acumulado de Ingresos por Cajero',
  // },
  // {
  //   id: 50,
  //   nombre: 'Acumulado de Ingresos por Estado de Origen y Cajero',
  // },
  // {
  //   id: 56,
  //   nombre: 'Listado de Recibos por Cajero',
  // },
  // {
  //   id: 140,
  //   nombre: 'Control de Documentos Bancarios por Unidad Recaudadora',
  // },
];

export const permissionConfig = {
  mainPermission: 'reportes_contabilidad',
};

const ReportesContabilidadOax = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visiblePreviewer, setVisiblePreviewer] = useState(false);
  const [base64, setBase64] = useState('');
  const [receptoresDePagos, setReceptoresDePagos] = useState([]);

  usePermissionMessage(permission);

  const formatos = [
    'pdf',
    'excel',
  ];

  const onCancel = () => {
    setVisible(false);
    form.resetFields();
    setSelectedRowKeys([]);
    setBase64('');
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _receptores,
      ] = await Promise.all([getReceptoresDePagos()]);
      if (mounted) {
        setReceptoresDePagos(_receptores);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);
  const nombreReporte = data.find((item) => item.id === selectedRowKeys[0])?.nombre;

  const formatPostValues = (ID, values) => {
    const keys = Object.keys(values);
    const URNames = {
      34: 'UnidadRecaudacion',
      49: 'Area',
      50: 'Recaudacion',
      56: 'UnidadRecaudacion',
      140: 'UnidadRecaudacion',
    };
    const Parametros = keys.map((e) => {
      const fields = {
        fecha_dia_de_cortes: () => values[e]?.format(DATE_FRONTEND_FORMAT),
        fecha_inicial: () => dateFormatterToReporteador(values[e]),
        fecha_final: () => dateFormatterToReporteador(values[e], false),
      };
      const dataType = {
        fecha_dia_de_cortes: 'Fecha',
        fecha_inicial: 'Fecha',
        fecha_final: 'Fecha',
        receptor_id: 'Entero',
      };
      const Valor = (fields[e] && fields[e]()) || values[e] || null;
      return {
        Nombre: e === 'UnidadDeRecaudacion' ? URNames[ID] : e,
        TipoParametro: dataType[e],
        Valor,
      };
    }).filter((e) => e.Valor !== null);
    return { Parametros, ID };
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const _values = form.getFieldsValue();
      const [key] = selectedRowKeys;
      if (_values.fechas) {
        [_values.FechaInicio, _values.FechaFinal] = _values.fechas;
        [_values.fecha_inicial, _values.fecha_final] = _values.fechas;
        delete _values.fechas;
      }
      const values = formatPostValues(key, _values);
      const args = [values];
      if (_values.tipo === 'excel') {
        args.push('excel');
      }
      const result = await postObtenerReporte(...args);
      if (result) {
        setBase64(result);
        if (_values.tipo === 'excel') {
          downloadBase64(result, `${nombreReporte}.xlsx`);
        } else {
          setVisiblePreviewer(true);
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickConsultar = () => {
    form.resetFields();
    setVisible(true);
  };

  const rules = {
    required: [{ required: true }],
  };

  const columns = [
    {
      titleText: 'Nombre del reporte',
      dataIndex: 'nombre',
      key: 'nombre',
      width: 350,
    },
  ];

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          customActions={[{
            icon: <FilePdfOutlined />,
            text: 'Consultar',
            onClick: onClickConsultar,
            hasPermission: permission.hasAllViewPermission,
          }]}
          rowKey="id"
          mobileColIndex={0}
          permission={permission}
        />
        <Modal
          open={visible}
          footer={null}
          closable={false}
          maskClosable={false}
          title={(
            <FormSubmitControls
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
              label="Consulta de Reporte"
              onFinishText="Ejecutar"
            />
          )}
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={() => onFinish()}
            scrollToFirstError
          >
            <Row gutter={10}>
              {[10052, 10044].includes(selectedRowKeys[0]) ? (
                <Col span={24}>
                  <Form.Item
                    label="Fecha Inicial y Final"
                    name="fechas"
                    rules={rules.required}
                  >
                    <DatePicker.RangePicker
                      placeholder=""
                      format={DATE_FRONTEND_FORMAT}
                    />
                  </Form.Item>
                </Col>
              ) : (
                <Col span={24}>
                  <Form.Item
                    label="Fecha de corte"
                    name="fecha_dia_de_cortes"
                    rules={rules.required}
                  >
                    <DatePicker
                      placeholder=""
                      format={DATE_FRONTEND_FORMAT}
                    />
                  </Form.Item>
                </Col>
              )}
              {selectedRowKeys[0] === 10044 && (
                <>
                  <Col span={24}>
                    <Form.Item
                      label="Receptor"
                      name="receptor_id"
                    >
                      <Select dataSource={receptoresDePagos} />
                    </Form.Item>
                  </Col>
                </>
              )}
              <Col span={24}>
                <Form.Item
                  label="Formato del Reporte"
                  rules={rules.required}
                  name="tipo"
                  tooltip="Elegir entre pdf y excel"
                >
                  <Select dataSource={formatos} />
                </Form.Item>
              </Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>

            </Row>
          </Form>
        </Modal>
      </Spin>
      <Previewer
        visible={visiblePreviewer}
        base64={base64}
        setVisible={(value) => {
          setVisiblePreviewer(value);
          onCancel();
        }}
        allowSend
        isImage={false}
        allowDownload
        fileName={data.find((item) => item.id === selectedRowKeys[0])?.nombre}
      />
    </Row>
  );
};

export default ReportesContabilidadOax;
